<template>
  <div class="bg-white">
    <el-row class="p-1">
      <!-- <el-dialog
        append-to-body
        title="Purchase Order Filter"
        :visible.sync="filterDialog"
      >
        <el-form class="form__input-inline" :model="pager" label-width="120px">
          <el-form-item label="Supplier" prop="supplier">
            <el-input v-model="pager.supplier"></el-input>
          </el-form-item>
          <el-form-item label="Quote" prop="quote_no">
            <el-input v-model="pager.quote_no"></el-input>
          </el-form-item>
          <el-form-item label="PO Date" prop="daterange">
            <el-date-picker
              type="daterange"
              range-separator="To"
              start-placeholder="Start date"
              end-placeholder="End date"
              v-model="pager.daterange"
            ></el-date-picker>
          </el-form-item>
          <div class="text-right">
            <el-button type="primary" size="mini" @click="performSearch"
              >Search</el-button
            >
          </div>
        </el-form>
      </el-dialog>
      <el-col class="text-right">
        <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          @click="filterDialog = true"
          >Filter</el-button
        > -->
      <el-col>
        <el-form
          class="text-right"
          :inline="true"
          @submit.native.prevent="fetch(1)"
          size="small"
        >
          <el-form-item>
            <!-- <el-input
              v-model="pager.search"
              placeholder="Search..."
              clearable
            ></el-input> -->
            <el-autocomplete
              v-model="pager.search"
              :fetch-suggestions="querySearch"
            >
              <el-select
                v-model="pager.search_by"
                slot="prepend"
                placeholder="Select"
                label="Select"
                @change="fetchList"
              >
                <el-option value="po" label="P.O. Number"></el-option>
                <el-option value="supplier" label="Supplier"></el-option>
              </el-select>
            </el-autocomplete>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="fetch(1)">Search</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-table
      :data="list.data"
      ref="purchaseorderTable"
      v-loading="isLoading"
      @row-click="rowClicked"
      :highlight-current-row="isComponent"
    >
      <el-table-column v-if="!isComponent" label="Actions" width="100">
        <template slot-scope="scope">
          <el-button
            title="View Purchase Order"
            @click="openItem(scope.row)"
            size="small"
            type="primary"
            circle
            icon="el-icon-folder-opened"
          >
          </el-button>
          <!-- <el-button
            v-show="isPending(scope.row.status)"
            title="Complete Purchase Order"
            @click="requestComplete(scope.row.id)"
            size="small"
            type="success"
            icon="el-icon-check"
            circle
          ></el-button> -->
        </template>
      </el-table-column>
      <el-table-column label="PO Number" prop="po_no" />
      <el-table-column label="Supplier" prop="supplier_name" />
      <el-table-column label="Status" prop="status" />
      <!-- <el-table-column label="PO Date" prop="po_date"></el-table-column> -->
      <el-table-column label="PO Date">
        <template slot-scope="scope">
          <span>{{ scope.row.po_date | dateFormat }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="Action">
        <template slot-scope="scope">
          
          <span v-else>{{ scope.row.item_status }}</span>
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="Date Created">
        <template slot-scope="scope">
          <span>{{ scope.row.created_at | dateFormat }}</span>
        </template>
      </el-table-column> -->
    </el-table>
    <el-pagination
      v-show="list.data.length"
      class="pt-1 pb-1"
      background
      layout="prev, pager, next"
      :total="list.paging.total"
      :page-size="pager.limit"
      :current-page="parseInt(list.paging.cur_page)"
      @current-change="fetch"
    ></el-pagination>
  </div>
</template>
<script>
import moment from "moment";
import Supplier from "@/models/Supplier";
import PurchaseOrder from "@/models/PurchaseOrder";
export default {
  name: "PurchaseOrderList",
  props: ["isComponent"],
  data() {
    return {
      isLoading: false,
      filterDialog: false,
      pager: {
        page: 1,
        limit: 25,
        search: "",
        status: "all",
        daterange: [],
        supplier: "",
        po_no: "",
        search_by: ""
      },
      po: [],
      supplier: []
    };
  },
  computed: {
    list() {
      return this.$store.getters["purchaseorder/list"];
    }
  },
  mounted() {
    this.fetch(1);
  },
  methods: {
    performSearch() {
      this.filterDialog = false;
      this.fetch(1);
    },
    fetch(page) {
      var obj = {
        page: page,
        limit: this.pager.limit,
        // search: this.pager.search,
        status: this.pager.status,
        supplier_name: this.pager.search,
        po_no: this.pager.search,
        search_by: this.pager.search_by
      };
      if (this.pager.daterange.length) {
        obj.created_at_from = moment(this.pager.daterange[0]).format(
          "YYYY-MM-DD"
        );
        obj.created_at_to = moment(this.pager.daterange[1]).format(
          "YYYY-MM-DD"
        );
      }
      this.isLoading = true;
      this.$store.dispatch("purchaseorder/getList", obj).then(() => {
        this.isLoading = false;
      });
    },
    openItem(item) {
      this.$router.push({
        name: "purchaseorder_info",
        params: { id: item.id }
      });
    },
    rowClicked(row) {
      if (this.isComponent) {
        this.$store.commit("purchaseorder/setActivePO", row);
        this.$refs.purchaseorderTable.setCurrentRow(row);
      }
    },
    requestComplete(id) {
      this.$confirm(
        `Are you sure you want to complete this purchase request?`,
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No"
        }
      )
        .then(() => {
          this.isLoading = true;
          PurchaseOrder.po_complete(id).then(resp => {
            this.isLoading = false;
            if (resp && resp.data.code == 200) {
              this.$notify({
                type: "success",
                message: resp.data.message,
                position: "bottom-right"
              });
            }
            // this.$router.push({ name: "purchaseorder" });
            this.fetch(1);
          });
        })
        .catch(() => {});
    },
    isPending(status) {
      return status == "Pending Order" ? true : false;
    },
    fetchList() {
      this.pager.search = "";
      if (this.pager.search_by == "supplier" && this.supplier.length <= 0) {
        Supplier.getGlossary().then(list => {
          if (list) {
            this.supplier = [];
            for (let s of list) {
              this.supplier.push({
                value: s.name,
                id: s.id
              });
            }
          }
        });
      } else if (this.pager.search_by == "po" && this.po.length <= 0) {
        PurchaseOrder.getList({
          limit: 999999999,
          status: "all"
        }).then(list => {
          if (list) {
            this.po = [];
            for (let p of list.data) {
              this.po.push({
                value: p.po_no
              });
            }
          }
        });
      }
    },
    querySearch(queryString, cb) {
      let list = [];
      if (this.pager.search_by == "supplier") {
        list = queryString
          ? this.supplier.filter(this.createFilter(queryString))
          : this.supplier;
      } else if (this.pager.search_by == "po") {
        list = queryString
          ? this.po.filter(this.createFilter(queryString))
          : this.po;
      }
      cb(list);
    },
    createFilter(queryString) {
      return item => {
        return (
          item.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    }
  }
};
</script>
